import { Injectable } from '@angular/core';
import { SessionStorageService } from './session_storage';
import { PROPOSAL_ID, REQUEST_ID } from 'src/app/constants/constants';
import { P30APIService } from './api';
import { UntypedFormGroup, UntypedFormBuilder, FormArray, Validators, FormGroup } from '@angular/forms';
import { Observable, map } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpResponse } from '@angular/common/http';
import { LegalEntity } from '../interfaces/LegalEntities';
import { isNonEmptyString } from 'ng-zorro-antd/core/util';
import { DataServiceEntityQuestions } from './data_service_entity_questions';
import { AcquisitionEntityQuestion } from '../interfaces/EntityIndicatorQuestion';
import { Attachment } from '../interfaces/Attachment';

@Injectable({
  providedIn: 'root'
})
export class DataServiceEntitySelection {
  salesLegalEntitySelectionQuestionGroupForm!: FormGroup;
  constructor(private session: SessionStorageService,
    private fb: UntypedFormBuilder,
    private apiService: P30APIService,
    private message: NzMessageService, private dataServiceEntityQuestions: DataServiceEntityQuestions) { }


  getLegalEntities(): Observable<HttpResponse<any>> {
    return this.apiService.getLegalEntities(this.session.getItem(PROPOSAL_ID)).pipe(
      map(legalEntities => {
        return legalEntities;
      })
    );
  }
  createLegalEntity(legalEntity: LegalEntity): Observable<HttpResponse<any>> {
    const data = {
      "ccn": legalEntity.ccn,
      "companyName": legalEntity.companyName,
      "jurisdiction": legalEntity.jurisdiction,
      "ownershipDetail": legalEntity.ownershipDetail,
      "legalEntityComments": legalEntity.legalEntityComments ? legalEntity.legalEntityComments : null,
      "typeofLegalEntity": "Buyer",
      "requestId": Number(this.session.getItem(REQUEST_ID))
    }
    return this.apiService.createLegalEntity(this.session.getItem(PROPOSAL_ID), data).pipe(
      map(legelaEntities => {
        return legelaEntities;
      })
    )
  }



  updateLegalEntity(legalEntity: LegalEntity): Observable<HttpResponse<any>> {
    const data = {
      "ccn": legalEntity.ccn,
      "companyName": legalEntity.companyName,
      "jurisdiction": legalEntity.jurisdiction,
      "ownershipDetail": legalEntity.ownershipDetail,
      "legalEntityComments": legalEntity.legalEntityComments ? legalEntity.legalEntityComments : null,
      "typeofLegalEntity": "Buyer",
      "requestId": Number(this.session.getItem(REQUEST_ID))
    }
    return this.apiService.updateLegalEntity(this.session.getItem(PROPOSAL_ID), Number(legalEntity.legalEntityId), data).pipe(
      map(legalEntity => {
        return legalEntity;
      })
    );
  }


  patchLegalEntitiesToFormGroup(loader: boolean, form: UntypedFormGroup, formArray: FormArray) {
    let entityQuestions: any = [];
    let entityQuestionsSet: any = [];
    formArray.clear();
    this.apiService.getEntityIndicatorQuestion(this.session.getItem(PROPOSAL_ID))
      .subscribe({
        next: (event) => {
          if (event.body) {
            entityQuestions = [...event.body];
            this.getLegalEntities().subscribe({
              next: (event) => {
                if (event.body) {
                  let entities: LegalEntity[] = [];
                  entities = [...event.body];
                  entities.forEach(item => {
                    if (item.ccn == "NA") {
                      const control = form.controls["comments"]
                      control.setValue(item.legalEntityComments);
                      control.updateValueAndValidity();
                      form.controls["legalEntity"].setValue(item.ccn);
                      form.updateValueAndValidity();
                    } else {
                      entityQuestionsSet = entityQuestions.filter((x: { legalEntityId: any; }) => x.legalEntityId === item.legalEntityId);
                      const legalEntityForm = this.fb.group({
                        legalEntityId: item.legalEntityId,
                        legalEntityName: [item.companyName],
                        ccn: item.ccn,//[this.legalEntities.filter(data =>data.companyName === leglaEntity.companyName)[0].ccn],
                        companyName: item.companyName,
                        jurisdiction: item.jurisdiction,
                        ownershipDetail: item.ownershipDetail,
                        entityQuestionsId: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].entityQuestionsId : '',
                        activeRegistration: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveActiveRegistrationsInOtherStatesCountries : '',
                        activeRegistrationComments: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingActiveRegistrations : '',
                        subsidiaries: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveSubsidiaries : '',
                        subsidiariesComments: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingSubsidiaries : '',
                        anyEmployees: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveAnyEmployees : '',
                        anyEmployeesComments: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingEmployees : '',
                        activeBankaccount: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveActiveBankAccounts : '',
                        activeBankaccountComments: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingBankAccounts : '',
                      })
                      formArray.push(legalEntityForm);
                    }

                  })
                }

              },
              error: (err) => {
                console.log("Unable to get legal entity record in the database table ", err);
                this.message.error('Unable to retrieve legal entities!');
              },
              complete: () => { }
            });
          }
          else {
            this.getLegalEntities().subscribe({
              next: (event) => {
                if (event.body) {
                  let entities: LegalEntity[] = [...event.body];
                  entities.forEach(item => {
                    if (item.ccn == "NA") {
                      const control = form.controls["comments"]
                      control.setValue(item.legalEntityComments);
                      control.updateValueAndValidity();
                      form.controls["legalEntity"].setValue(item.ccn);
                      form.updateValueAndValidity();
                    }
                  });
                }
              }
            });
          }
        }
      });

  }

  createOrUpdateLegalEntityRecordIfRecordExist(form: UntypedFormGroup, formArray: FormArray, event: any) {
    let legalEntities: LegalEntity[] = [];
    for (let i = 0; i < formArray.length; i++) {
      legalEntities.push(formArray.at(i).value);
    }

    for (let entity of event.body) {
      if (entity.ccn != "NA" && entity.legalEntityId) {
        const stillExists = legalEntities.some(data => data.ccn == entity.ccn);
        if (!stillExists) {
          this.apiService.deleteLegalEntity(this.session.getItem(PROPOSAL_ID), entity.legalEntityId).subscribe({
            next: () => { return; },
            error: (err) => { console.error("Unable to delete legal entity record", err); }
          });
        }
      }
    }

    for (let entity of event.body) {
      if (legalEntities.length > 0 && entity.ccn != "NA") {
        let index = legalEntities.findIndex(data => data.ccn == entity.ccn);
        if (index !== -1) {
          legalEntities[index].legalEntityId = entity.legalEntityId;
        }
      }
    }
    if (legalEntities.length == 0) {
      legalEntities = [...event.body];
      let index = legalEntities.findIndex(data => data.ccn == "NA");
      if (index !== -1) {
        legalEntities[index].legalEntityComments = form.controls["comments"].value;
      }
    }
    legalEntities.forEach(element => {
      if (element.legalEntityId) {
        this.updateLegalEntity(element).subscribe({
          next: (event) => {
            return;
          }
        });
      } else {
        this.createLegalEntity(element).subscribe({
          next: (event) => {
            element.legalEntityId = event.body
            return;
          }
        });
      }

    });
  }


  createOrUpdateDissolutionLegalEntityRecordIfRecordExist(form: UntypedFormGroup, formArray: FormArray, event: any) {
    let formQuestionsArray = form.controls["legalEntitiesQuestionsFormArray"] as FormArray;
    let legalEntities: LegalEntity[] = [];
    for (let i = 0; i < formQuestionsArray.length; i++) {
      legalEntities.push(formQuestionsArray.at(i).value);
    }

    for (let entity of event.body) {
      if (entity.ccn != "NA" && entity.legalEntityId) {
        const stillExists = legalEntities.some(data => data.ccn == entity.ccn);
        if (!stillExists) {
          if (entity.entityQuestionsId) {
            this.apiService.deleteEntityIndicatorQuestion(this.session.getItem(PROPOSAL_ID), entity.entityQuestionsId).subscribe({
              next: () => {
                this.apiService.deleteLegalEntity(this.session.getItem(PROPOSAL_ID), entity.legalEntityId).subscribe({
                  next: () => { return; },
                  error: (err) => { console.error("Unable to delete legal entity record", err); }
                });
              },
              error: (err) => { console.error("Unable to delete entity question record", err); }
            });
          } else {
            this.apiService.deleteLegalEntity(this.session.getItem(PROPOSAL_ID), entity.legalEntityId).subscribe({
              next: () => { return; },
              error: (err) => { console.error("Unable to delete legal entity record", err); }
            });
          }
        }
      }
    }

    for (let entity of event.body) {
      if (legalEntities.length > 0 && entity.ccn != "NA") {
        let index = legalEntities.findIndex(data => data.ccn == entity.ccn);
        if (index !== -1) {
          legalEntities[index].legalEntityId = entity.legalEntityId;
        }
      }
    }
    if (legalEntities.length == 0) {
      legalEntities = [...event.body];
      let index = legalEntities.findIndex(data => data.ccn == "NA");
      if (index !== -1) {
        legalEntities[index].legalEntityComments = form.controls["comments"].value;
      }
    }
    legalEntities.forEach(element => {
      if (element.legalEntityId) {
        this.updateLegalEntity(element).subscribe({
          next: (event) => {
            let entityQuestionsSet = formQuestionsArray.value.filter((item: AcquisitionEntityQuestion) => item.legalEntityId == element.legalEntityId);
            if (entityQuestionsSet && entityQuestionsSet.length > 0) {
              let dissolutionEntityQuestion: any = {
                "requestId": Number(this.session.getItem(REQUEST_ID)),
                "legalEntityId": element.legalEntityId,
                "assests": "",
                "ownershipInterest": "",
                "nameOfEntityBeingAcquired": "",
                "sellerEntity": "",
                "approximateCost": "",
                "descriptionOfAsset": "",
                "jurisdiction": element.jurisdiction,
                "haveActiveRegistrationsInOtherStatesCountries": entityQuestionsSet[0].activeRegistration,
                "commentsForHavingActiveRegistrations": entityQuestionsSet[0].activeRegistrationComments,
                "haveSubsidiaries": entityQuestionsSet[0].subsidiaries,
                "commentsForHavingSubsidiaries": entityQuestionsSet[0].subsidiariesComments,
                "needBankAccounts": false,
                "commentsForNeedingBankAccounts": "",
                "willThereBeaNeedForAdditionalContributionsAfterInitialInvestment": false,
                "commentsForNeedingAdditionalContributions": "",
                "haveAnyEmployees": entityQuestionsSet[0].anyEmployees,
                "commentsForHavingEmployees": entityQuestionsSet[0].anyEmployeesComments,
                "haveActiveBankAccounts": entityQuestionsSet[0].activeBankaccount,
                "commentsForHavingBankAccounts": entityQuestionsSet[0].activeBankaccountComments,
                "willTheNewEntityBeRegisteredInOtherStatesCountries": false,
                "commentsForNewEntityBeingRegistered": "",
                "willTheSurvivingEntityChangeItsNameAfterTheMerger": false,
                "commentsForSurvivingEntityChangingName": "",
                "entityType": "",
                "typeOfSale": "",
                "investmentMethod": ""
              };

              if (entityQuestionsSet[0].entityQuestionsId === 0) {
                let entityQuestionsDetails: any = [];
                this.apiService.getEntityIndicatorQuestion(this.session.getItem(PROPOSAL_ID))
                  .subscribe({
                    next: (event) => {
                      if (event.body) {
                        entityQuestionsDetails = [...event.body];
                        entityQuestionsDetails = entityQuestionsDetails.filter((x: { legalEntityId: any; eType: string }) => x.legalEntityId === element.legalEntityId);
                      }
                      this.dataServiceEntityQuestions.updateDissolutionEntityQuestion(entityQuestionsDetails[0].entityQuestionsId, dissolutionEntityQuestion).subscribe({
                        next: (event) => {
                          return;
                        }
                      });
                    }
                  });
              }
              else {
                this.dataServiceEntityQuestions.updateDissolutionEntityQuestion(entityQuestionsSet[0].entityQuestionsId, dissolutionEntityQuestion).subscribe({
                  next: (event) => {
                    return;
                  }
                });
              }
            }
          }
        });
      } else {
        this.createLegalEntity(element).subscribe({
          next: (event) => {
            element.legalEntityId = event.body.legalEntityId
            let entityQuestionsSet = formQuestionsArray.value.filter((item: { ccn: number | undefined; }) => item.ccn == element.ccn);
            if (entityQuestionsSet && entityQuestionsSet.length > 0) {
              let dissolutionEntityQuestion: any = {
                "requestId": Number(this.session.getItem(REQUEST_ID)),
                "legalEntityId": event.body.legalEntityId,
                "assests": "",
                "ownershipInterest": "",
                "nameOfEntityBeingAcquired": "",
                "sellerEntity": "",
                "approximateCost": "",
                "descriptionOfAsset": "",
                "jurisdiction": element.jurisdiction,
                "haveActiveRegistrationsInOtherStatesCountries": entityQuestionsSet[0].activeRegistration,
                "commentsForHavingActiveRegistrations": entityQuestionsSet[0].activeRegistrationComments,
                "haveSubsidiaries": entityQuestionsSet[0].subsidiaries,
                "commentsForHavingSubsidiaries": entityQuestionsSet[0].subsidiariesComments,
                "needBankAccounts": false,
                "commentsForNeedingBankAccounts": "",
                "willThereBeaNeedForAdditionalContributionsAfterInitialInvestment": false,
                "commentsForNeedingAdditionalContributions": "",
                "haveAnyEmployees": entityQuestionsSet[0].anyEmployees,
                "commentsForHavingEmployees": entityQuestionsSet[0].anyEmployeesComments,
                "haveActiveBankAccounts": entityQuestionsSet[0].activeBankaccount,
                "commentsForHavingBankAccounts": entityQuestionsSet[0].activeBankaccountComments,
                "willTheNewEntityBeRegisteredInOtherStatesCountries": false,
                "commentsForNewEntityBeingRegistered": "",
                "willTheSurvivingEntityChangeItsNameAfterTheMerger": false,
                "commentsForSurvivingEntityChangingName": "",
                "entityType": "",
                "typeOfSale": "",
                "investmentMethod": ""
              };
              this.dataServiceEntityQuestions.addDissolutionEntityQuestion(dissolutionEntityQuestion).subscribe({
                next: (event) => {
                  return;
                }
              });
            }
            return;
          }
        });
      }

    });
  }

  createOrUpdateLegalEntityRecordIfNoRecord(form: UntypedFormGroup) {
    let formArray = form.controls["legalEntitiesFormArray"] as FormArray;
    if (formArray.length > 0) {
      for (let i = 0; i < formArray.length; i++) {
        let leglaEntity: LegalEntity = {
          ccn: formArray.value[i].ccn,
          companyName: formArray.value[i].companyName,
          jurisdiction: formArray.value[i].jurisdiction,
          ownershipDetail: formArray.value[i].ownershipDetail,
          legalEntityComments: '',
          typeofLegalEntity: formArray.value[i].typeofLegalEntity
        }
        this.createLegalEntity(leglaEntity).subscribe({
          next: (event) => {
            leglaEntity.legalEntityId = event.body.legalEntityId
            return;
          }
        });
      }
    } else {
      let leglaEntity: LegalEntity = {
        ccn: "NA",
        companyName: "",
        jurisdiction: "",
        ownershipDetail: "",
        legalEntityComments: form.controls["comments"].value,
        typeofLegalEntity: ""
      }
      this.createLegalEntity(leglaEntity).subscribe({
        next: (event) => {
          return;
        }
      });
    }
  }

  createOrUpdateDissolutionLegalEntityRecordIfNoRecord(form: UntypedFormGroup) {
    let formArray = form.controls["legalEntitiesQuestionsFormArray"] as FormArray;
    let entityValidation= form.controls["legalEntity"] as FormGroup;
    if (formArray.length > 0) {
      for (let i = 0; i < formArray.length; i++) {
        let leglaEntity: LegalEntity = {
          ccn: formArray.value[i].ccn,
          companyName: formArray.value[i].companyName,
          jurisdiction: formArray.value[i].jurisdiction,
          ownershipDetail: formArray.value[i].ownershipDetail,
          legalEntityComments: '',
          typeofLegalEntity: formArray.value[i].typeofLegalEntity
        }
        this.createLegalEntity(leglaEntity).subscribe({
          next: (event) => {
            leglaEntity.legalEntityId = event.body.legalEntityId
            let dissolutionEntityQuestion: any = {
              "requestId": Number(this.session.getItem(REQUEST_ID)),
              "legalEntityId": event.body.legalEntityId,
              "assests": "",
              "ownershipInterest": "",
              "nameOfEntityBeingAcquired": "",
              "sellerEntity": "",
              "approximateCost": "",
              "descriptionOfAsset": "",
              "jurisdiction": formArray.value[i].jurisdiction,
              "haveActiveRegistrationsInOtherStatesCountries": formArray.value[i].activeRegistration,
              "commentsForHavingActiveRegistrations": formArray.value[i].activeRegistrationComments,
              "haveSubsidiaries": formArray.value[i].subsidiaries,
              "commentsForHavingSubsidiaries": formArray.value[i].subsidiariesComments,
              "needBankAccounts": false,
              "commentsForNeedingBankAccounts": "",
              "willThereBeaNeedForAdditionalContributionsAfterInitialInvestment": false,
              "commentsForNeedingAdditionalContributions": "",
              "haveAnyEmployees": formArray.value[i].anyEmployees,
              "commentsForHavingEmployees": formArray.value[i].anyEmployeesComments,
              "haveActiveBankAccounts": formArray.value[i].activeBankaccount,
              "commentsForHavingBankAccounts": formArray.value[i].activeBankaccountComments,
              "willTheNewEntityBeRegisteredInOtherStatesCountries": false,
              "commentsForNewEntityBeingRegistered": "",
              "willTheSurvivingEntityChangeItsNameAfterTheMerger": false,
              "commentsForSurvivingEntityChangingName": "",
              "entityType": "",
              "typeOfSale": "",
              "investmentMethod": ""
            };
            this.dataServiceEntityQuestions.addDissolutionEntityQuestion(dissolutionEntityQuestion).subscribe({
              next: (event) => {
                return;
              }
            });
          }
        });

      }
    } 
    else if(entityValidation.value == "NA") {
      let leglaEntity: LegalEntity = {
        ccn: "NA",
        companyName: "",
        jurisdiction: "",
        ownershipDetail: "",
        legalEntityComments: form.controls["comments"].value,
        typeofLegalEntity: ""
      }
      this.createLegalEntity(leglaEntity).subscribe({
        next: (event) => {
          leglaEntity.legalEntityId = event.body.legalEntityId
          return;
        }
      });
    }
  }

  submitLegalEntitySelection(form: UntypedFormGroup, formArray: FormArray): Promise<boolean> {
    if (form.valid) {
      return new Promise<boolean>((resolve) => {
        this.getLegalEntities().subscribe({
          next: (event) => {
            if (event.body) {
              this.createOrUpdateLegalEntityRecordIfRecordExist(form, formArray, event);
            } else {
              this.createOrUpdateLegalEntityRecordIfNoRecord(form);
            }
            resolve(true);
          },
          error: (err) => {
            console.error("Unable to submit legal entity selection", err);
            resolve(false);
          }
        });
      });
    } else {
      Object.values(form.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return Promise.resolve(false);
    }
  }

  submitDissolutionLegalEntitySelection(form: UntypedFormGroup, formArray: FormArray): Promise<boolean> {
    if (form.valid) {
      return new Promise<boolean>((resolve) => {
        this.getLegalEntities().subscribe({
          next: (event) => {
            if (event.body) {
              this.createOrUpdateDissolutionLegalEntityRecordIfRecordExist(form, formArray, event);
            } else {
              this.createOrUpdateDissolutionLegalEntityRecordIfNoRecord(form);
            }
            resolve(true);
          },
          error: (err) => {
            console.error("Unable to submit dissolution legal entity selection", err);
            resolve(false);
          }
        });
      });
    } else {
      Object.values(form.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return Promise.resolve(false);
    }
  }

  reviewAndValidateEntitySelection(form: UntypedFormGroup): Promise<boolean> {
    let formArray = form.controls["legalEntitiesFormArray"] as FormArray;
    const control = form.controls["comments"]
    if (formArray.length == 0 && !isNonEmptyString(control.value)) {
      control.setValidators([Validators.required]);
      control.markAsDirty();
      control.updateValueAndValidity();
      return Promise.resolve(false);
    } else {
      control.removeValidators([Validators.required]);
      control.updateValueAndValidity();
      return Promise.resolve(true);
    }

  }
}
